import { observer } from 'mobx-react-lite'
import { Navigate, useLocation } from 'react-router'
import { useEntitiesContext } from 'entities/EntitiesExport'
import PageNotFound from 'pages/pageNotFound'
import { getLegacyVueRedirectPath } from 'pages/pageNotFound/hooks/useRedirectRouter'
import { PageNotFoundRoutes } from 'pages/pageNotFound/route/type'

export const PageNotFoundGate = observer(() => {
  const { authStore } = useEntitiesContext()
  const { pathname } = useLocation()

  const legacyRedirectPath = getLegacyVueRedirectPath(pathname)
  if (legacyRedirectPath) {
    return <Navigate to={legacyRedirectPath} replace />
  }

  if (authStore.isLoggedIn) {
    return <Navigate to={`/${PageNotFoundRoutes.root}`} replace />
  }

  return <PageNotFound />
})
